import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

/* istanbul ignore next */
class ScrollToTop extends React.PureComponent {
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.node,
  };
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/app/containers/ScrollToTop/index.js